import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';

import Label from './label';
import Option from './option';

export default function Dropdown(props) {
  const {
    children,
    onSelectOption,
    options,
    selectedValue,
    top,
    right,
    variant = 'large',
    borderless,
    staticLabel,
    minWidth = 'max-content',
    ...rest
  } = props;
  const [open, setOpen] = React.useState(false);
  const containerRef = React.useRef(null);
  const selectedOption = _.find(options, { value: selectedValue });

  function handleClickOutside(event) {
    if (open && containerRef.current) {
      if (containerRef.current.contains(event.target)) {
        return;
      }

      setOpen(false);
    }
  }

  React.useEffect(() => {
    if (open) {
      document.addEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [open]);

  function handleSelect(option) {
    setOpen(false);
    onSelectOption(option.value);
  }

  function handleToggle() {
    setOpen((prevOpen) => !prevOpen);
  }

  return (
    <div ref={containerRef} {...rest}>
      {children &&
        children({
          onToggle: handleToggle,
          selectedOption,
        })}

      {!children && staticLabel && (
        <Label variant={variant} onToggle={handleToggle} borderless={borderless}>
          {staticLabel}
        </Label>
      )}

      {!children && !staticLabel && selectedOption && (
        <Label variant={variant} onToggle={handleToggle} borderless={borderless}>
          {selectedOption.label}
        </Label>
      )}

      {open && (
        <Container open={open} top={top} right={right} variant={variant} minWidth={minWidth}>
          {_.map(options, (option) => (
            <Option
              key={option.key}
              onSelect={handleSelect}
              option={option}
              selected={selectedOption && option.value === selectedOption.value}
            />
          ))}
        </Container>
      )}
    </div>
  );
}

const Container = styled.div`
  background-color: white;
  border-radius: 4px;
  border: 1px solid #d2d5da;
  box-shadow: 0 3px 4px 1px rgba(0, 0, 0, 0.12);
  max-height: 500px;
  overflow-y: auto;
  position: absolute;
  right: ${(props) => props.right || 'auto'};
  top: ${(props) => props.top || 'auto'};
  width: max-content;
  min-width: ${(props) => props.minWidth};
  z-index: 6;
`;
